var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FormInputWithBtn } from '@styled/Form';
import React, { Component, createRef, forwardRef } from 'react';
import LibDatePicker, { DateUtils } from 'react-day-picker';
import ReactDOM from 'react-dom';
import { FaRegCalendarAlt } from 'react-icons/fa';
require('react-day-picker/lib/style.css');
var DAY_PICKER_WIDTH = 220;
var DAY_PICKER_HEIGHT = 255;
var WRAPPER_STYLE = {
    position: 'absolute',
    zIndex: 2000,
    backgroundColor: '#fff',
    borderStyle: 'solid',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#E7EAF0',
};
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.dateChanged = function (value) {
            _this.setState({ value: value, show: false });
            var cb = _this.props.callback;
            cb && cb(value);
            _this.closePortal();
        };
        _this.closePortal = function (e) {
            var _a;
            if (_this.calRef.current && _this.calRef.current.contains((_a = e === null || e === void 0 ? void 0 : e.target) !== null && _a !== void 0 ? _a : null))
                return;
            _this.setState({ show: false });
        };
        _this.openCalendar = function (e) {
            e.preventDefault();
            document.body.addEventListener('click', _this.closePortal);
            _this.setState({ show: true });
        };
        _this.returnNewValue = function () {
            return _this.state.value;
        };
        _this.btnRef = createRef();
        _this.calRef = createRef();
        _this.closePortal = _this.closePortal.bind(_this);
        _this.Calendar = forwardRef(function (props, ref) {
            return React.createElement(Calendar, __assign({}, props, { forwardRef: ref }));
        });
        _this.state = {
            value: props.date,
            show: false,
        };
        return _this;
    }
    DatePicker.prototype.componentDidUpdate = function (_a) {
        var date = _a.date;
        if (this.props.date !== date) {
            this.setState({ value: this.props.date });
        }
    };
    DatePicker.prototype.render = function () {
        var _a, _b;
        var formatted = this.state.value.toLocaleDateString();
        var _c = this.props, to = _c.to, from = _c.from;
        return (React.createElement(React.Fragment, null,
            React.createElement(FormInputWithBtn, { "$iconOnTheRight": true, onClick: this.openCalendar, "$cursor": 'pointer' },
                React.createElement("div", { tabIndex: 0 }, formatted),
                React.createElement("span", { tabIndex: 0, ref: this.btnRef, onClick: this.openCalendar },
                    React.createElement(FaRegCalendarAlt, { size: 18 }))),
            this.state.show && (React.createElement(this.Calendar, { ref: this.calRef, btnWidth: (_b = (_a = this.btnRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.offsetWidth, value: this.state.value, from: from, to: to, dateChanged: this.dateChanged, target: this.btnRef.current, closePortal: this.closePortal }))));
    };
    return DatePicker;
}(Component));
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (d) {
            var noon = new Date(d.setHours(12));
            _this.setState({ value: noon, initialMonth: noon });
            _this.props.dateChanged(noon);
        };
        _this.dayClickHandler = function (d) {
            _this.setState({ value: d, initialMonth: d });
            _this.props.dateChanged(new Date(d.setHours(12)));
        };
        _this.getPosition = function () {
            var target = _this.props.target;
            if (!target || !_this.props.btnWidth) {
                return {};
            }
            var _a = target.getBoundingClientRect(), top = _a.top, left = _a.left, height = _a.height;
            if (top + height + 1 + DAY_PICKER_HEIGHT > window.innerHeight) {
                return { top: top - 2 - DAY_PICKER_HEIGHT, left: left - DAY_PICKER_WIDTH + _this.props.btnWidth };
            }
            return { top: top + height + 1, left: left - DAY_PICKER_WIDTH + _this.props.btnWidth };
        };
        _this.state = {
            value: props.value,
            initialMonth: props.value,
        };
        return _this;
    }
    Calendar.prototype.componentWillUnmount = function () {
        document.body.removeEventListener('click', this.props.closePortal);
    };
    Calendar.prototype.render = function () {
        var _a = this.props, from = _a.from, to = _a.to;
        var _b = this.state, value = _b.value, initialMonth = _b.initialMonth;
        return ReactDOM.createPortal(React.createElement("div", { ref: this.props.forwardRef, style: __assign(__assign({}, WRAPPER_STYLE), this.getPosition()) },
            React.createElement(LibDatePicker, { selectedDays: function (day) { return DateUtils.isSameDay(value, day); }, onDayClick: this.dayClickHandler, month: initialMonth, fromMonth: from, toMonth: to, modifiers: { highlighted: initialMonth } })), document.getElementById('portal'));
    };
    return Calendar;
}(Component));
export default DatePicker;
